//NUMBERS
export const ZERO = "ZERO";
export const DOUBLE_ZERO = "DOUBLE_ZERO";
export const ONE = "ONE";
export const TWO = "TWO";
export const THREE = "THREE";
export const FOUR = "FOUR";
export const FIVE = "FIVE";
export const SIX = "SIX";
export const SEVEN = "SEVEN";
export const EIGHT = "EIGHT";
export const NINE = "NINE";

// OPERATIONS

export const DOT = "DOT"
export const PLUS = "PLUS";
export const MINUS = "MINUS";
export const MULTIPLE = "MULTIPLE";
export const DIVIDE = "DIVIDE";
export const EQUAL = "EQUAL";
export const SQRT = "SQRT";
export const X2 = "X2";
export const REVERSE = "REVERSE";
export const ONEDIVIDEX = "ONEDIVIDEX";
export const PERCENT = "PERCENT";


//Service
export const CLEAR = "CLEAR";
export const DELETE = "DELETE";